import { Store } from 'components/common/types/Store.types';
import { useSelector } from 'react-redux';

export const calculateLeftPositionOffset = (): string => {
  const isCampaignDrawerOpen = useSelector((state: Store) => state.dealManagement.isCampaignDrawerOpen);

  const SIDEBAR_MENU_WIDTH = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--sidebar-width').trim(),
  );
  const CAMPAIGN_DRAWER_WIDTH = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--campaign-drawer-width').trim(),
  );
  const DEAL_LINE_STRIP_MIN_WIDTH = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--deal-line-strip-min-width').trim(),
  );
  const DEAL_LINE_STRIP_X_PADDING = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--deal-line-strip-x-padding').trim(),
  );
  const SECONDARY_PANEL_WIDTH = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--secondary-panel-width').trim(),
  );
  const RIGHT_SIDEBAR_WIDTH = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--right-sidebar-width').trim(),
  );

  const VIEWPORT_WIDTH = window.innerWidth;

  let leftOffset = SIDEBAR_MENU_WIDTH;

  if (isCampaignDrawerOpen) {
    leftOffset += CAMPAIGN_DRAWER_WIDTH;
  }

  leftOffset += DEAL_LINE_STRIP_MIN_WIDTH + DEAL_LINE_STRIP_X_PADDING;

  return `${Math.min(leftOffset, VIEWPORT_WIDTH - (SECONDARY_PANEL_WIDTH + RIGHT_SIDEBAR_WIDTH + DEAL_LINE_STRIP_X_PADDING))}px`;
};

export const actionButtonClassName =
  'p-1 flex justify-start items-center text-neutral-900 rounded-md body-base space-x-2 enabled:hover:bg-primary-50 disabled:text-neutral-400 disabled:bg-neutral-200 disabled:cursor-not-allowed';

export const actionButtonTitle = (action: string): string => `${action} deal line`;
